module.exports = __webpack_public_path__ + "img/logo-header-mobile.ff8030be.png";